/* eslint-disable no-console */
import React from "react";
import PropTypes from "prop-types";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/**
 * For Doubles (Individuals + Doubles):
 * - Typically grouped by `week.section || "general"`.
 * - We might have multiple "sections" if you are splitting by skill level, etc.
 */
export default function DoublesDraw({
  groupedWeeks, // e.g. { "general": [...], "SectionA": [...], etc. }
  handleOpenScoreSheet,
  handleOpenPrintableScoreSheet,
}) {
  const sectionKeys = Object.keys(groupedWeeks).sort();

  if (!sectionKeys.length) {
    return <Typography>No Doubles draws found.</Typography>;
  }

  return (
    <>
      {sectionKeys.map((secKey) => {
        const arr = groupedWeeks[secKey];
        const label = secKey === "general" ? "No Section" : `Section: ${secKey}`;

        return (
          <Accordion key={secKey}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{label}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Week</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Matches</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {arr.map((weekDraw, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{weekDraw.week}</TableCell>
                        <TableCell>{weekDraw.date}</TableCell>
                        <TableCell>
                          {weekDraw.matches.map((match, i2) => (
                            <Typography key={i2}>
                              {match.team1?.name || "Pair A"} vs{" "}
                              {match.team2?.name || "Pair B"}
                            </Typography>
                          ))}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            onClick={() => handleOpenScoreSheet(weekDraw)}
                          >
                            Add/Update Scores
                          </Button>
                          <Button
                            variant="outlined"
                            sx={{ ml: 1 }}
                            onClick={() => handleOpenPrintableScoreSheet(weekDraw)}
                          >
                            Printable Score Sheet
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
}

DoublesDraw.propTypes = {
  groupedWeeks: PropTypes.object,
  handleOpenScoreSheet: PropTypes.func.isRequired,
  handleOpenPrintableScoreSheet: PropTypes.func.isRequired,
};
